import Button from "./Button";
import "./Pagination.css";

/*
  Pagination Component

  Previous / next with the current position. Works for numbered pages (server
  side). Labels are passed in so the component stays language-agnostic.

  page       current page (1-based)
  pages      total pages (null when the total is not known)
  total      total records (optional, shown when known)
  hasMore    whether a next page exists (used when `pages` is unknown)
  maxPage    optional hard limit (the API reaches only that deep)
  onPage     called with the new page
  labels     { previous, next, summary(page, pages, total), limit }
  disabled   while loading
*/

const Pagination = ({ page, pages = null, total = null, hasMore = false, maxPage = null, onPage, labels, disabled = false, className = "" }) => {
  const lastKnown = pages ? (maxPage ? Math.min(pages, maxPage) : pages) : null;
  const canNext = !disabled && (lastKnown ? page < lastKnown : hasMore) && (!maxPage || page < maxPage);
  const canPrevious = !disabled && page > 1;
  const reachedLimit = Boolean(maxPage && pages && pages > maxPage && page >= maxPage);
  return (
    <nav className={`ui-pagination ${className}`} aria-label={labels.nav}>
      <Button size="sm" appearance="outline" variant="neutral" disabled={!canPrevious} onClick={() => onPage(page - 1)}>
        {labels.previous}
      </Button>
      <span className="ui-pagination-summary" aria-live="polite">
        {labels.summary(page, lastKnown ? (pages || lastKnown) : null, total)}
      </span>
      <Button size="sm" appearance="outline" variant="neutral" disabled={!canNext} onClick={() => onPage(page + 1)}>
        {labels.next}
      </Button>
      {reachedLimit && <span className="ui-pagination-note">{labels.limit}</span>}
    </nav>
  );
};

export default Pagination;
